import '@/styles/theme.css';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Toaster } from '@/components/ui/sonner';
import { TooltipProvider } from '@/components/ui/tooltip';
import { createQueryClient } from '@/lib/query-client';
import { ThemeProvider } from '@/lib/theme';
import { createAppRouter } from '@/router';

const queryClient = createQueryClient({
  onUnauthenticated: (redirect) => {
    // Pendant une transition, le `beforeLoad` de `_auth` gère déjà la redirection.
    if (router.state.status === 'pending') return;
    void router.navigate({ to: '/login', search: { redirect } });
  },
});
const router = createAppRouter(queryClient);

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element #root not found');
}

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <TooltipProvider delayDuration={300}>
          <RouterProvider router={router} />
          <Toaster position="bottom-right" duration={4000} />
        </TooltipProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </StrictMode>,
);
